import { Card, } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ComicCard.css';

const ComicCard = ({ comic }) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';
  const originalComicCover = `https://www.wzdhm2.cc/static/upload/book/${comic.book_id}/cover.jpg`;
  
  // Construct the comic cover URL properly. If it is a remote absolute URL, proxy it.
  const comicCover = (comic.cover && !comic.cover.includes('default-cover.jpg'))
    ? (comic.cover.startsWith('http')
        ? `${backendUrl}/api/images/proxy?url=${encodeURIComponent(comic.cover)}`
        : (comic.cover.startsWith('/') ? `${backendUrl}${comic.cover}` : `${backendUrl}/comics/${comic.cover}`))
    : `${backendUrl}/api/images/proxy?url=${encodeURIComponent(originalComicCover)}`;
  
  return (
    <Link to={`/comic/${comic.book_id}`} className="comic-card-link">
      <Card className="h-100 d-flex flex-column">
        <Card.Img variant="top" src={comicCover} />
        <Card.Body className="d-flex flex-column">
          <Card.Title title={comic.title} className="flex-grow-1">{comic.title}</Card.Title>
          <Card.Text as="div">
            <strong>Author:</strong> {comic.author}<br />
            <strong>Status:</strong> {comic.status}<br />
            <strong>Region:</strong> {comic.region}<br />
            <strong>Updated:</strong> {new Date(comic.update_time).toISOString().slice(0, 10)}<br />
            <strong>Tags:</strong> {comic.tags && comic.tags.filter(tag => tag).join(', ')}
          </Card.Text>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default ComicCard;
